import { useEffect } from 'react'

const ExternalScripts = () => {
  const getCookieByName = (name) => {
    let match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'))
    return match ? match[1] : null
  }

  const setSegmentCookie = () => {
    if (
      typeof window !== `undefined` &&
      typeof window.analytics !== `undefined` &&
      typeof window.analytics.user !== `undefined` &&
      typeof window.analytics.user().anonymousId !== `undefined`
    ) {
      let cname = 'segment_anonymous_id'
      let cvalue = window.analytics.user().anonymousId()
      let exdays = 30
      let d = new Date()
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
      let expires = 'expires=' + d.toUTCString()
      if (getCookieByName('segment_anonymous_id') === null) {
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
      }
    } else {
      setTimeout(() => {
        setSegmentCookie()
      }, 1500)
    }
  }

  useEffect(() => {
    setSegmentCookie()
  }, [])

  return null
}

export default ExternalScripts
